import { apiRequest } from '../apiRequest'

const getBusyDays = (data) =>
  apiRequest(`/user/call-requests/free-busy/?pro_id=${data}`).get()

export const calendarApi = {
  getBusyDays,
}
